import { render, staticRenderFns } from "./ButtonStyle.vue?vue&type=template&id=304240a7"
import script from "./ButtonStyle.vue?vue&type=script&lang=js"
export * from "./ButtonStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports